module.exports = __webpack_public_path__ + "img/diapositiva-8-1.8fd46a08.png";